import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'markdownBold',
  standalone: true
})
export class MarkdownBoldPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    if (value == null) {
      return '';
    }

    const escaped = String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const html = escaped
      .replace(/\*\*([^\n*][^\n]*?)\*\*/g, '<strong>$1</strong>')
      .replace(/(?<!<strong>)11 3004-4242(?!<\/strong>)/g, '<strong>11 3004-4242</strong>')
      .replace(
        /(?<!<strong>)atendimento\.beneficios@semparar\.com\.br(?!<\/strong>)/g,
        '<strong>atendimento.beneficios@semparar.com.br</strong>'
      )
      .replace(/https?:\/\/[^\s<"'&]+((&amp;)[^\s<"'&]*)*/gi, (match) => {
        const url = match.replace(/&amp;/g, '&');
        return `<a class="chat-link" href="#" data-url="${url}">${match} <mat-icon>open_in_new</mat-icon></a>`;
      });

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
